// extracted by mini-css-extract-plugin
export default {"productGallery":"oO-z","inQuickShop":"pO-z"};